import request from './request'

/**
 * 將檔案上傳到指定的資料夾。
 * @param {string} fileFolder - 要上傳檔案的資料夾（Avatar、Attachment）。
 * @param {Object} data - 要上傳的檔案資料。
 * @param {string} data.fileName - 檔案的名稱。
 * @param {string} data.base64Content - 檔案的 base64 編碼內容。
 * @returns {Promise} 在成功時解決伺服器回應的 Promise。
 */
function uploadFile(fileFolder, data) {
  return request({
    url: '/attachment/uploadFile',
    method: 'post',
    params: { fileFolder },
    data: data,
  })
}

/**
 * 取得檔案的 base64 編碼內容。
 * @param {string} fileKey - 要取得的檔案的鍵。
 * @returns {Promise} 在成功時解決伺服器回應的 Promise，包含檔案的 base64 編碼內容。
 */
function getObjectToBase64(fileKey) {
  return request({
    url: '/attachment/getObjectToBase64',
    method: 'get',
    params: { fileKey },
  })
}

/**
 * 下載檔案。
 * @param {string} fileKey - 要下載的檔案的鍵。
 * @returns {Promise} 在成功時解決伺服器回應的 Promise，包含檔案的二進位資料。
 */
function downloadObject(fileKey) {
  return request({
    url: '/attachment/downloadObject',
    method: 'get',
    params: { fileKey },
    responseType: 'blob',
  })
}

export default {
  uploadFile,
  getObjectToBase64,
  downloadObject,
}
